import { useSearchParams } from 'react-router-dom';

const useSearchParamsWithFallback = () => {
  try {
    return useSearchParams();
  } catch {
    return [new URLSearchParams(window.location.search)];
  }
};

export const useLocale = (): [string, (locale: string) => void] => {
  const [params] = useSearchParamsWithFallback();
  const locale = params.get('page_locale') || I18n.locale || 'en';

  const setLocale = (locale: string) => params.set('page_locale', locale);

  return [locale, setLocale];
};
